let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5ejxC")).then(() => parcelRequire('b33bB'));